import { usePersistedLocationState } from "@hooks/usePersistedLocationState";
import { FC, useMemo } from "react";
// eslint-disable-next-line no-restricted-imports -- StateAwareNavigate wraps react-router-dom's Navigate directly
import { Navigate, NavigateProps } from "react-router-dom";

export const StateAwareNavigate: FC<NavigateProps> = ({ state, ...rest }) => {
    const persistedLocationState = usePersistedLocationState();
    const finalState = useMemo(
        () => ({
            ...persistedLocationState,
            ...state,
        }),
        [persistedLocationState, state],
    );

    return <Navigate {...rest} state={finalState} />;
};
